
import React from "react";
import { FaPlus } from "react-icons/fa";
import useScrollReveal from "../../Hooks/useScrollReveal";
import "./InsightImageRight.css";

function InsightImageRight({title = "Insights", image, imageAlt = "", description, category = "FEATURED ARTICLE", articleTitle, readMoreUrl = "#",}) {
    const { elementRef, isVisible } = useScrollReveal();

    return (
        <section
            ref={elementRef}
            className={`insight-right ${
                isVisible ? "is-visible" : ""
            }`}
        >
            <div className="insight-right__heading">
                <h2>{title}</h2>
            </div>

            <div className="insight-right__image">
                <img src={image} alt={imageAlt} loading="lazy" />
            </div>

            <div className="insight-right__description">
                <p>{description}</p>
            </div>

            <article className="insight-right__featured">
        <span className="insight-right__category">
          {category}
        </span>

                <div className="insight-right__featured-content">
                    <h3>{articleTitle}</h3>

                    <a
                        href={readMoreUrl}
                        target="_blank"
                        className="insight-right__read-more"
                        aria-label={`Leer más: ${articleTitle}`}
                        rel="noreferrer"
                    >
                        <span>Leer más</span>
                        <FaPlus aria-hidden="true" />
                    </a>
                </div>
            </article>
        </section>
    );
}

export default InsightImageRight;
